import { useView, getRoute } from "@/functions";

export default {
    path: '/',
    component: useView('accounts/index_page'),
    children: [
        getRoute('/account-confirmation/:id', 'accountsConfirmation', 'accounts/account_confirmaiton_page', { title: 'Accounts Confirmation' }),
        getRoute('/account-authorization', 'accountAuthorization', 'accounts/account_authorization_page', { title: 'Accounts Confirmation' }),
    ],
};